@for (item of filterOptions | async; track item) {
  <div>
    <div class="form-group">
      @if (item.text) {
        <label>{{item.text | translate}}</label>
      }
      <input type="text" class="form-control" (change)="onChange(filter)" [(ngModel)]="item.value"
        [ngModelOptions]="{standalone: true}" />
      </div>
    </div>
  }
